import { Link } from "react-router-dom"
import { FaPlus, FaEdit, FaTrash } from "react-icons/fa"
import { useAppContext } from "../context/AppContext"
import "./TagsPage.css"
import { AiOutlineLoading } from "react-icons/ai"

const TagsPage = () => {
  const { tags, deleteTag, loadingApp } = useAppContext()

  const handleDeleteTag = (id) => {
    if (window.confirm("Tem certeza que deseja excluir esta etiqueta? Esta ação não pode ser desfeita.")) {
      deleteTag(id)
    }
  }

  return (
    <div className="tags-page">      
    {loadingApp && <div className="loading"><AiOutlineLoading size="50px"/></div>}
    
      <div className="page-header">
        <h1 className="page-title">Etiquetas</h1>
        <Link to="/tags/new" className="btn btn-primary">
          <FaPlus className="icon-left" /> Nova Etiqueta
        </Link>
      </div>

      {tags.length > 0 ? (
        <div className="tags-grid">
          {tags.map((tag) => (
            <div className="tag-card" key={tag.id}>
              <div className="tag-card-header">
                <div className="tag-info">
                  <div className="tag-color" style={{ backgroundColor: tag.color }}></div>
                  <h3 className="tag-name">{tag.name}</h3>
                </div>
                <div className="tag-actions">
                  <Link to={`/tags/edit/${tag.id}`} className="tag-action-btn">
                    <FaEdit />
                  </Link>
                  <button className="tag-action-btn delete" onClick={() => handleDeleteTag(tag.id)}>
                    <FaTrash />
                  </button>
                </div>
              </div>

              <div className="tag-card-body">
                <div className="tag-detail">
                  <span className="tag-detail-label">Valor:</span>
                  <span className="tag-detail-value">R$ {tag.paymentAmount.toFixed(2)}</span>
                </div>


                <div className="tag-detail">
                  <span className="tag-detail-label">Horário:</span>
                  <span className="tag-detail-value">
                      {tag.time ? <>
                      {tag.defaultStartTime} - {tag.defaultEndTime}
                    </> : <>Não informado</>}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="no-tags">
          <p>Você ainda não tem etiquetas cadastradas</p>
          <Link to="/tags/new" className="btn btn-primary">
            <FaPlus className="icon-left" /> Criar Etiqueta
          </Link>
        </div>
      )}
    </div>
  )
}

export default TagsPage

